import { FC } from "react";
import styles from "./Decor.module.css";

const Decor: FC = () => {
  return (
    <>
      <div className={styles.eth_decor}>
        <img src="/images/landing_v2/smile.png" />
        <img src="/images/landing_v2/smile_blur.png" />
      </div>

      {/* <div className={styles.eth_decor}>
        <img src="/images/landing_v2/eth_blur.png" />
        <img src="/images/landing_v2/eth.png" />
      </div> */}
      {/* <img className={styles.triangle} src="/images/landing_v2/triangle.png" /> */}

      <div className={styles.smile}>
        <img src="/images/landing_v2/smile.png" />
        <img src="/images/landing_v2/smile_blur.png" />
      </div>
      <img
        className={styles.like}
        src="/images/landing_v2/triangle_right.png"
      />
      {/* <img className={styles.like} src="/images/landing_v2/like.png" /> */}
      {/* <img
        className={styles.mineCraft}
        src="/images/landing_v2/minecraft.png"
      /> */}

      {/* <img className={styles.trophy} src="/images/landing_v2/trophy.png" /> */}
    </>
  );
};

export default Decor;
